import React, { lazy } from 'react';

// project imports
import AdminGaurd from 'routes/route-guard/AdminGuard';
import MainLayout from 'views/layouts/MainLayout';
import Loadable from 'components/common/Loadable';

// Pages
const SessionsManagementPage = Loadable(lazy(() => import('views/pages/sessions/admin')));

const MainRoutes = {
	path: '/',
	element: (
		<AdminGaurd>
			<MainLayout />
		</AdminGaurd>
	),
	children: [
		{
			path: '/admin/sessions',
			element: <SessionsManagementPage />
		}
	]
};

export default MainRoutes;
